/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export const DEFAULT_SETTINGS = {
  story_editor: {
    selectionAlwaysOnDisplay: true,
    hasHeadlines: true,
    showSpeedDial: false,
    hasFloatingGeneralSettings: true,
    styles: {
      shell: "",
      container: "px-20",
    },
    floatingToolbar: {
      findAndReplace: {
        show: false,
      },
      specialCharacters: {
        show: false,
      },
      underline: {
        show: false,
      },
      fontSize: {
        show: false,
      },
    },
    fixedToolbar: {
      topPosition: "top-28 xl:top-14",
      findAndReplace: {
        show: true,
      },
      specialCharacters: {
        show: true,
      },
      underline: {
        show: true,
      },
      fontSize: {
        show: true,
      },
    },
  },
  template_editor: {
    selectionAlwaysOnDisplay: true,
    hasHeadlines: false,
    showSpeedDial: false,
    hasFloatingGeneralSettings: false,
    styles: {
      shell: "",
      container: "",
    },
    floatingToolbar: {
      findAndReplace: {
        show: false,
      },
      specialCharacters: {
        show: false,
      },
      underline: {
        show: false,
      },
      fontSize: {
        show: false,
      },
    },
    fixedToolbar: {
      topPosition: "top-28 xl:top-14",
      findAndReplace: {
        show: false,
      },
      specialCharacters: {
        show: true,
      },
      underline: {
        show: true,
      },
      fontSize: {
        show: true,
      },
    },
  },
  job_editor: {
    selectionAlwaysOnDisplay: true,
    hasHeadlines: false,
    showSpeedDial: false,
    hasFloatingGeneralSettings: false,
    styles: {
      shell: "max-h-96 overflow-y-scroll overflow-x-clip",
      container: "",
    },
    floatingToolbar: {
      findAndReplace: {
        show: false,
      },
      specialCharacters: {
        show: false,
      },
      underline: {
        show: false,
      },
      fontSize: {
        show: false,
      },
    },
    fixedToolbar: {
      topPosition: "top-0",
      findAndReplace: {
        show: false,
      },
      specialCharacters: {
        show: true,
      },
      underline: {
        show: true,
      },
      fontSize: {
        show: true,
      },
    },
  },
} as const;

// These are mutated in setupEnv
export const INITIAL_SETTINGS: Record<EditorKey, any> = {
  ...DEFAULT_SETTINGS,
};

export type EditorKey = keyof typeof DEFAULT_SETTINGS;

export type Settings = typeof INITIAL_SETTINGS;
